module.exports = __webpack_public_path__ + "static/media/shuttleTrainedIcon.100caa46.png";